import type { FunctionComponent } from 'react'
import React from 'react'
import { FontIcon } from '@arvoreeducacao/bonsai-ds'
import { useVoiceControl, getVoiceStrings } from 'context/voice-control'

import { MicButton } from './VoiceMicButton.styles'

const VoiceMicButton: FunctionComponent = () => {
  const voice = useVoiceControl()

  if (!voice.isFlagEnabled || !voice.isSupported) return null

  const strings = getVoiceStrings(voice.locale)
  const recognized = voice.status === 'recognized'
  const listening = voice.status === 'listening'

  const handleClick = () => {
    if (voice.isEnabled) {
      voice.openHelp()
    } else {
      voice.openConfirm()
    }
  }

  const label = voice.isEnabled ? strings.listening : strings.enableTitle

  return (
    <MicButton
      type="button"
      data-testid="voice-mic-button"
      onClick={handleClick}
      $on={voice.isEnabled}
      $listening={listening}
      $recognized={recognized}
      aria-label={label}
      title={label}
    >
      <FontIcon iconName="mic" size={20} />
    </MicButton>
  )
}

export default VoiceMicButton
